import './_CardComments.scss';
import { ICardCommentProps, ICardCommentsProps } from './types';
import * as React from 'react';
import { CARD_CLASS } from '../../constants';
import { COMMENTS_TITLE } from '../../wording';
import { Userpic } from 'kui';
import * as moment from 'moment/moment';
import { blockMarkdown } from '../../../../../../helper/markdownHelper';
import { EUserSettingsCommentSort } from '../../../../../../types/rest/IRestAuthUser';
import { DriveDocHOC } from '../driveDocs/hocs/DriveDocHOC/DriveDocHOC';
import ReactHtmlParser from 'react-html-parser';
import { onImgLoad } from '../helpers/onImgLoad';

export const CardComments = ({
    comments,
    driveDocs,
    order,
    onHeightChange,
    onToggleLoadingImg,
}: ICardCommentsProps) => {
    const className = CARD_CLASS + '__comments';
    const classItems = className + '-items';

    return (
        <div className={className}>
            <div className={className + '-title'}>{COMMENTS_TITLE}</div>
            <div className={`${classItems} ${order === EUserSettingsCommentSort.DESC ? classItems + '--desc' : '' }`}>
                {comments.map((comment) => {
                    const {
                        driveDocIds,
                        author,
                        id,
                        text ,
                        created
                    } = comment;
                    return <Comment
                        key={id}
                        driveDocIds={driveDocIds}
                        author={author}
                        text={text}
                        created={created}
                        driveDocs={driveDocs}
                        onHeightChange={onHeightChange}
                        onToggleLoadingImg={onToggleLoadingImg}
                    />;
                })}
            </div>
        </div>
    );
}

function Comment({
    author,
    created,
    driveDocIds,
    driveDocs,
    text ,
    onHeightChange,
    onToggleLoadingImg,
}: ICardCommentProps) {
    const className = CARD_CLASS + '__comments';
    const classComment = className + '-comment';

    const ref = React.useRef(null);
    const [markdown, setMarkdown] = React.useState('');
    React.useEffect(() => {
        setMarkdown(blockMarkdown(text));
    }, [text]);

    React.useEffect(() => {
        if (!onHeightChange || !markdown || !ref.current) return;
        const cleanup = onImgLoad(ref.current, onHeightChange, onToggleLoadingImg);
        return cleanup;
    }, [markdown]);

    return <div className={classComment}>
        <div className={classComment + '-header'}>
            <div className={classComment + '-author'}>
                <Userpic size={24} src={author.photoUrl}/>
                <div className={classComment + '-name'}>{author.fullName}</div>
            </div>
            <div className={classComment + '-date'}>
                {moment(created * 1000).format('DD MMM YY [at] HH:mm')}
            </div>
        </div>
        {text &&
            <div
                className={classComment + '-text'}
                ref={ref}
            >
                {ReactHtmlParser(markdown)}
            </div>
        }
        {driveDocIds && !!driveDocIds.length &&
            <div className={classComment + '-attachments'}>
                {driveDocIds.map(driveDocId => (
                    <DriveDocHOC
                        key={driveDocId}
                        driveDoc={driveDocs.find(item => item.id === driveDocId)}
                    />
                ))}
            </div>
        }
    </div>
}
